import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';

export const groupTradeNewRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/trades/new',
}).lazy(() =>
  import('pages/group/Trades/GroupTradeNewPage/GroupTradeNewPage').then((d) => d.Route)
);
